const utils = {
  checkLinkValidity: (link) => {
    const urlPattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
    return urlPattern.test(link);
  },
};

export default utils;
